<template>
  <div id="taxes-fees">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Listagem de taxas">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <InfoPanel height="155" class="info-panel">
          <template #content>
            <!-- NOME DO HOTEL -->
            <Heading v-if="hotel" class="info-panel--title heading--size-2">
              {{ hotel.nome }}
            </Heading>
          </template>
        </InfoPanel>

        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <!-- MENU DOS HOTÉIS -->
          <PmwHotelNav
            :links="menuLinks"
            :hide="isHotelAbsolute ? ['diferenciais', 'banners'] : ['banners']"
            active="taxas"
            class="menu-nav"
          />
          <Heading>
            Ações da página
          </Heading>

          <!-- BOTÃO CADASTRAR -->
          <PmwButton
            :hasIcon="true"
            id="create"
            variation="pmw-primary"
            class="page-actions--button"
            @click.stop.prevent="$router.push({ path: `${hotel.codigo}/novo` })"
          >
            Criar taxa
          </PmwButton>

          <!-- BOTÃO EDITAR -->
          <PmwButton
            :disabled="disableEditPmwButton"
            variation="pmw-primary"
            class="page-actions--button"
            @click.stop.prevent="
              $router.push({
                path: `${hotel.codigo}/editar/${selectedRows[0].codigo}`
              })
            "
          >
            Editar
          </PmwButton>

          <!-- BOTÃO DESATIVAR -->
          <PmwButton
            v-show="showInactivateButton"
            :disabled="disabledInactivatePmwButton"
            variation="red-100"
            class="page-actions--button"
            @click.stop.prevent="deleteModal(selectedRows.codigo, 'lateral')"
          >
            Desativar
          </PmwButton>

          <!-- BOTÃO REATIVAR -->
          <PmwButton
            v-show="showReactivateButton"
            variation="pmw-primary"
            class="page-actions--button"
            @click.stop.prevent="reactivateModal(selectedRows[0].codigo)"
          >
            Reativar
          </PmwButton>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <span class="filters">
          <!-- BUSCA -->
          <SearchInput
            v-model="filterByName"
            placeholder="Buscar taxas"
            class="filters--search-input"
          />
        </span>

        <!-- FILTRO STATUS -->
        <span class="extra-filters">
          <FilterDropdown
            v-model="statusFilter"
            :options="statusFilterOptions"
            class="extra-filters--status"
          />
        </span>

        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :colsMinWidths="colsMinWidths"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <!-- ITEM - VALOR -->
          <template v-slot:valor="data">
            <div v-if="data.rowDataObj.tipoValor === 1">
              {{ data.rowDataObj.valor }}%
            </div>
            <div v-else>
              {{ data.rowDataObj.valorMostrar }}
            </div>
          </template>

          <!-- ITEM - TIPO DE VALOR -->
          <template v-slot:tipoValor="data">
            <div v-if="data.rowDataObj.tipoValor === 1">
              Percentual
            </div>
            <div v-else>
              Fixo
            </div>
          </template>

          <!-- ITEM - TIPO DE MULTIPLICADOR -->
          <template v-slot:tipoMultiplicador="data">
            <div v-if="data.rowDataObj.tipoMultiplicador === 1">
              Room Night
            </div>
            <div v-else>
              Reserva
            </div>
          </template>

          <!-- ITEM - TIPO DE MULTIPLICADOR -->
          <template v-slot:status="data">
            <div v-if="data.rowDataObj.status === true">
              Ativo
            </div>
            <div v-else>
              Inativo
            </div>
          </template>

          <!-- ITEM - EDITAR -->
          <template v-slot:editar="data">
            <button
              class="links--edit"
              @click.stop.prevent="
                $router.push({
                  path: `${hotel.codigo}/editar/${data.rowDataObj.codigo}`
                })
              "
            >
              Editar
            </button>
          </template>

          <!-- ITEM - EXCLUIR -->
          <template v-slot:excluir="data">
            <div v-if="data.rowDataObj.status === true">
              <button
                class="links--delete"
                @click.stop.prevent="
                  deleteModal(data.rowDataObj.codigo, 'listagem')
                "
              >
                Desativar
              </button>
            </div>

            <!-- ITEM - REATIVAR -->
            <div v-else>
              <button
                class="links--reactivate"
                @click.stop.prevent="reactivateModal(data.rowDataObj.codigo)"
              >
                Reativar
              </button>
            </div>
          </template>
        </DataTable>

        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterTable"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterTable.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          class="pagination"
          @changePagination="changePagination"
        />

        <!-- MODAL DELEÇÃO -->
        <PmwAlertModal
          v-model="showDeleteModal"
          closeButton
          title="Desabilitar taxa"
          icon="pmw-trash-can"
          iconColor="red-100"
          cancelButtonColor="grey-90"
          confirmButtonColor="red-100"
          confirmButtonText="Sim, quero desativar"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disableTaxes()"
        >
          <template #text>
            Ao desativar essa taxa, ela estará indisponível para uso. <br />
            Você tem certeza de que quer fazer isso?
          </template>
        </PmwAlertModal>

        <!-- MODAL REATIVAÇÃO -->
        <PmwAlertModal
          v-model="showReactivateModal"
          closeButton
          title="Atenção"
          @alert-modal-cancel="cancelReactivate()"
          @alert-modal-confirm="reactivateTaxe()"
        >
          <template #text>
            Ao reativar essa taxa, ela estará disponíve para uso. <br />
            Você tem certeza de que quer fazer isso?
          </template>
        </PmwAlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes da lib */
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'

/** Imports do projeto */
import { mapGetters } from 'vuex'
import { converToCurrency } from '@/helpers/math'
import { capitalizeString } from '@/helpers/string'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import hotelCommonsMixin from '@/mixins/hotelCommonsMixin'

export default {
  name: 'TaxesList',
  mixins: [hotelCommonsMixin],
  components: {
    PmwAlertModal,
    PmwButton,
    DataTable,
    Heading,
    PmwPagination,
    SearchInput,
    SidebarLayout2,
    InfoPanel,
    SidebarBlock,
    FilterDropdown
  },
  data() {
    return {
      breadcrumb: [],

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Nome',
          name: 'nome'
        },
        {
          alias: 'Valor',
          name: 'valor'
        },
        {
          alias: 'Tipo de valor',
          name: 'tipoValor'
        },
        {
          alias: 'Tipo de multiplicador',
          name: 'tipoMultiplicador'
        },
        {
          alias: 'Status',
          name: 'status'
        },
        {
          alias: 'Ações',
          name: 'editar'
        },
        {
          name: 'excluir'
        }
      ],
      /** Largura mínima das colunas */
      colsMinWidths: {
        nome: '150px',
        valor: '100px',
        tipoValor: '100px',
        tipoMultiplicador: '100px',
        status: '60px',
        editar: '25px',
        excluir: '25px'
      },

      /** Opções do filtro de status */
      statusFilterOptions: [
        {
          label: 'Todos',
          value: -1,
          checked: false
        },
        {
          label: 'Ativo',
          value: 1,
          checked: true
        },
        {
          label: 'Inativo',
          value: 0,
          checked: false
        }
      ],

      /** V-model do filtro de status */
      statusFilter: {
        label: 'Ativo',
        value: 1,
        checked: true
      },

      /** Informações do hotel */
      hotel: null,

      /** V-model da busca */
      filterByName: '',

      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 10,
        startItemIndex: 1,
        lastItemIndex: 10,
        itemsPerPageOptions: [
          {
            text: '10',
            value: 10
          },
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },

      /** Linhas da tabela (dados) */
      rows: [],

      /** Armazena dados de retorno */
      allTaxes: [],

      /** Loading da tabela */
      loading: true,

      /** Array das linhas selecionadas */
      selectedRows: [],

      /** Taxa a ser deletada */
      taxesDelete: null,

      /** Taxa a ser reativada */
      taxesReactivate: null,

      /** Exibição da modal de deleção */
      showDeleteModal: false,

      /** Exibição da modal de reativação */
      showReactivateModal: false,

      /** Define se é desabilitado pela listagem ou barra lateral*/
      disableType: null,
      isHotelAbsolute: false
    }
  },
  computed: {
    showInactivateButton() {
      /** Exibição do botão de desativar */
      const isActive = this.selectedRows.some((item) => {
        return !item.status
      })
      if (!isActive) {
        return true
      }
      return false
    },

    showReactivateButton() {
      /** Exibição do botão de reativar taxa */
      if (this.selectedRows.length === 1 && !this.selectedRows[0].status) {
        return true
      }
      return false
    },

    /** Desabilita botão de desabilitar */
    disabledInactivatePmwButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },

    /** Desabilita botão de editar */
    disableEditPmwButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro da tela */
    filterTable() {
      return this.allTaxes.reduce((acc, curr) => {
        let match = true

        /** Filtra por status */
        match =
          +curr.data.status === +this.statusFilter.value ||
          +this.statusFilter.value === -1

        if (match) {
          acc.push(curr)
        }

        /** Filtra pelo input */
        const results = acc.filter((data) => {
          return (
            data.nome.toLowerCase().indexOf(this.filterByName.toLowerCase()) >
            -1
          )
        })
        return results
      }, [])
    },

    ...mapGetters('hotel', ['getCurrencySymbol'])
  },

  async created() {
    /** Retorno de dados do hotel */
    await this.$hotel.get(this.hotelId).then((response) => {
      this.hotel = response.data
      this.isHotelAbsolute = response.data.tarifarioAbsoluto

      /** Define o valor do breadcrumb */
      this.breadcrumb = [
        {
          label: 'Letsbook'
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: capitalizeString(this.hotel.nome),
          url: `/hoteis/editar/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: 'Taxas',
          url: `/hotel/taxas/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ]
    })

    /** Faz a chamada da listagem de dados da tabela */
    await this.getAllTaxes()
  },

  methods: {
    /** Retorna dados da listagem */
    async getAllTaxes() {
      this.loading = true
      await this.$taxesAndFees
        .listTaxes(this.$route.params.id)
        .then((response) => {
          const results = response.data

          const currency = this.hotel.moeda

          results.map(function(key, index) {
            results[index]['data'] = {
              nome: key.nome,
              tipoMultiplicador: key.tipoMultiplicador,
              tipoTaxa: key.tipoTaxa,
              tipoValor: key.tipoValor,
              valor: key.valor,
              status: key.ativo,
              id: key.codigo,
              codigo: key.codigo
            }
            if (key.data.tipoValor === 2) {
              key.data.valorMostrar = converToCurrency(key.valor, 0, currency)
            }
          })
          this.allTaxes = results
        })
      this.loading = false
    },

    /** Desabilitar taxas */
    disableTaxes() {
      if (this.disableType === 'listagem') {
        this.selectedRows = []
      }

      const DeleteTaxes = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.id)
            })
          : [this.taxesDelete]
      )
      this.$taxesAndFees
        .disableTaxes({ taxas: DeleteTaxes })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Taxa desativada com sucesso'
          })
          this.getAllTaxes()
          this.resetPagination()
          this.selectedRows = []
          this.disableType = null
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativada taxa'
          })
        })
    },

    /** Reativar taxa */
    reactivateTaxe() {
      this.$taxesAndFees
        .reactivateTaxe(this.taxesReactivate)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Taxa reativada com sucesso'
          })
          this.getAllTaxes()
          this.resetPagination()
          this.selectedRows = []
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao reativar taxa'
          })
        })
    },

    /** Controle de deleção */
    deleteModal(taxeId, disableType) {
      this.disableType = disableType
      this.showDeleteModal = true
      this.taxesDelete = taxeId
    },

    /** Cancela deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.taxesDelete = null
      this.disableType = null
    },

    /** Controle de reativação */
    reactivateModal(taxeId) {
      this.showReactivateModal = true
      this.taxesReactivate = taxeId
    },

    /** Cancela reativação */
    cancelReactivate() {
      this.showReactivateModal = false
      this.taxesReactivate = null
    },

    /** Verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Usado para controle da paginação */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  ::v-deep {
    p {
      margin: 0;
    }
    .select--button {
      font-weight: 500;
    }
  }
}
.page-actions {
  .menu-nav {
    max-height: calc(100vh - 415px);
    overflow-y: scroll;
  }
  padding-top: 30px;
  &--button {
    width: 100%;
    cursor: pointer;
    margin-bottom: 10px;

    & + .page-actions--button {
      margin-bottom: 10px;
    }
  }
  &--tip-text {
    color: $pmw-gray-darkest;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}
.links {
  &--edit {
    color: $pmw-blue;
    font-weight: font-weight('weight-medium');
    border: none;
    background-color: inherit;
  }
  &--delete {
    color: $pmw-error;
    font-weight: font-weight('weight-medium');
    border: none;
    background-color: inherit;
  }
  &--reactivate {
    color: $pmw-blue;
    font-weight: font-weight('weight-medium');
    border: none;
    background-color: inherit;
  }
}

.links--edit::v-deep .pmw-col.pmw-td {
  justify-content: center;
  background-color: blue;
}
::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}

.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;

  &--search-input {
    width: 232px;
  }

  &--more {
    width: 225px;
  }
}

.extra-filters {
  display: flex;
  margin-bottom: 25px;

  &--status {
    width: 190px;
  }
}

.links {
  border: none;
  background-color: inherit;
  &.edit {
    color: $pmw-blue;
  }
  &.delete {
    color: $pmw-error;
  }
}
.datatable {
  ::v-deep {
    max-height: none;

    .pmw-col.pmw-th:nth-child(7),
    .pmw-col.pmw-th:nth-child(8) {
      max-width: 77px;
    }

    .pmw-col.pmw-th:nth-child(7),
    .pmw-col.pmw-th:nth-child(8) {
      border-right: none;
      pointer-events: none;
      .pmw-sort-icons {
        display: none;
      }
    }

    .pmw-col.pmw-td:nth-child(8),
    .pmw-col.pmw-td:nth-child(7) {
      justify-content: center;
      max-width: 77px;
    }
  }

  .action {
    &--item {
      font-size: font-size('size-small');
    }
  }
}
.filters-select {
  display: flex;
  width: 100%;
  position: relative;
  height: 40px;
  border: none;
  border-bottom: 1px solid $pmw-gray-darkest;

  & ::v-deep .pmw-dropdown--trigger-button {
    /** Remove o espaço antes do texto do dropdown de mais filtros */
    padding: 0;
  }
}
::v-deep .content--white_card {
  padding: {
    top: 40px;
    bottom: 40px;
  }
}
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
#create::v-deep .pmw-button--label[data-v-72e7e03f] {
  margin: auto auto auto -10px;
}
</style>
